import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import './Chat.css';
import { useChatContext } from './ChatContext/ChatContext';
import Arrow from "../../assets/icons/arrow.svg";
import { ReactComponent as Send } from "../../assets/icons/send.svg";
import Tail from "../../assets/icons/messageTail.svg";
import Read from "../../assets/icons/arrowsRead.svg";

export default function Chat() {
    const { userName } = useParams<{ userName: string }>();
    const decodedName = decodeURIComponent(userName || '');
    const { chats } = useChatContext();

    const user = chats.find(chat => chat.name === decodedName);

    // Локальное состояние сообщений
    const [messages, setMessages] = useState([
        { id: 1, text: 'Привет! Как дела?', sender: 'received' },
        { id: 2, text: 'Всё отлично! А у тебя?', sender: 'sent' },
    ]);

    const [inputValue, setInputValue] = useState('');

    const handleSendMessage = (e: React.FormEvent) => {
        e.preventDefault();
        if (!inputValue.trim()) return;

        const newMessage = {
            id: Date.now(),
            text: inputValue,
            sender: 'sent' as const,
        };

        setMessages(prev => [...prev, newMessage]);
        setInputValue('');
    };

    if (!user) {
        return <div>Пользователь не найден</div>;
    }

    return (
        <div className="chatMain">
            <div className="chatHeader">
                <Link to="/chats" className="arrowReturnChat">
                    <img src={Arrow} />
                </Link>
                <img src={user.cover} alt="Аватар" className="chatUserAvatar" />
                <div className="chatUserInfo">
                    <h2>{user.name}</h2>
                    <p className="chatUserStatus">{user.status}</p>
                </div>
            </div>

            <div className="chatMessagesContainer">
                {messages.map((msg) => (
                    <div key={msg.id} className={`message ${msg.sender}`}>
                        <p>{msg.text}</p>
                        <span className="time">10:32</span>
                        <img src={Tail} alt="" className="tail" />
                        <img src={Read} alt="" className="arrowsRead" />
                    </div>
                ))}
            </div>

            <form onSubmit={handleSendMessage} className="chatInputBlock">
                <input
                    type="text"
                    placeholder="Написать сообщение"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    className="chatInput"
                />
                <button type="submit" className="chatSendButton">
                    <Send className="sendIcon" />
                </button>
            </form>
        </div>
    );
}